<template>
    <app-layout>
        <template #header>
            <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                A2P Registration
            </h2>
        </template>

        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8 shadow sm:rounded-md bg-white">
                <template v-if="tries<max_tries">
                    One moment while we check your payment ...
                        <font-awesome-icon
                            :icon="['far', 'spinner']"
                            class="fa-spin"
                            v-show="loading"
                        />
                </template>
                <template v-else>
                    We had a problem receiving a payment update from Stripe, please contact support.
                </template>
            </div>
        </div>
    </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";

export default {
    name: 'A2P-Status',
    props: [""],
    components: {
        AppLayout,
    },
    data() {
        return {
            tries: 0,
            max_tries: 20,
            loading: true,
        }
    },
    mounted() {
        this.checkForPaidStatus();
    }, 
    methods: {
        checkForPaidStatus() {
            axios.get('/verified/check-payment-status').then((response) => {
                if (response.data) {
                    this.$inertia.get(route('a2p.stripeSuccess'));
                } else {
                    if (this.tries < this.max_tries) {
                        setTimeout(() => {
                            this.checkForPaidStatus();
                        }, 500);
                        this.tries++;
                    } else {
                        this.loading = false;
                    }
                    
                }
            });
        }
        

    }
};
</script>
